import { OrderStatusEnum } from '@modules/orders-module/enums/order-status.enum'

export const CancelOrderStatuses: OrderStatusEnum[] = [
	OrderStatusEnum.CANCELED,
	OrderStatusEnum.REJECTED,
	OrderStatusEnum.EXPIRED,
]
